/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function RemoteJobRunBodyFromJSON(json) {
    return RemoteJobRunBodyFromJSONTyped(json, false);
}
export function RemoteJobRunBodyFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        arguments: json['arguments'],
    };
}
export function RemoteJobRunBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        arguments: value.arguments,
    };
}
